import DevNotice from "./DevNotice.jsx";
import useThemeProps from "./useThemeProps.jsx";

export default function Image(props) {
  props = useThemeProps({ props, name: "Image" });
  let {
    handler: Component = (props) => (
      <DevNotice {...props}>No image handler specified</DevNotice>
    ),
    ...restProps
  } = props;
  return <Component {...restProps} />;
}
